import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=645a8543&scoped=true&"
import script from "./UserMessage.vue?vue&type=script&lang=js&"
export * from "./UserMessage.vue?vue&type=script&lang=js&"
import style0 from "./UserMessage.vue?vue&type=style&index=0&id=645a8543&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a8543",
  null
  
)

export default component.exports